// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS206: Consider reworking classes to avoid initClass
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
import _ from 'underscore';

import CutSite from 'molbio/enzymes/backbone/CutSite';
import Enzymes, {Enzyme} from 'molbio/enzymes/backbone/Enzymes';
import {Cut} from 'molbio/enzymes/EnzymeConstants';
import {Collection, SelectableOptions} from 'molbio/maps/selectables/Selectables';
import {Selection} from 'molbio/maps/selectables/Selection';

interface CutSitesOptions extends SelectableOptions<CutSite> {
  enzymes: Enzymes;
  selection: Selection;
}

export default class CutSites extends Collection<CutSite> {
  selection!: Selection;

  static initClass(): void {
    this.prototype.model = CutSite;
  }

  override initialize(models: Array<CutSite>, options: CutSitesOptions): void {
    super.initialize(models);
    const {enzymes} = options;
    this.selection = options.selection;

    this.createCutSites(enzymes);
    this.listenTo(
      enzymes,
      'change:visible',
      (enzyme: Enzyme, visible: boolean, options?: {trigger: boolean}) => {
        this.changeEnzyme(enzyme, visible, options);
      }
    );
    this.listenTo(
      enzymes,
      'change:cutPositions',
      (enzyme: Enzyme, cuts: Array<Cut>, options?: {trigger: boolean}) => {
        this.resetEnzyme(enzyme, options);
      }
    );
    this.on('change:selected', (cutSite: CutSite, selected: boolean) => {
      this.removeIfInvisible(cutSite, selected);
    });
  }

  changeEnzyme(enzyme: Enzyme, visible: boolean, options?: {trigger: boolean}): void {
    let cutsite;
    let array = this.where({enzyme});
    // maintain ones that are selected
    if (visible) {
      for (const cut of enzyme.get('cutPositions')) {
        const selected = this.getSelected(enzyme, cut.position);
        if (selected != null) {
          // eslint-disable-next-line no-restricted-syntax
          array = _.without(array, selected);
        } else {
          this.add(
            new CutSite({
              enzyme,
              position: cut.position,
              strand: cut.strand,
              color: enzyme.color(),
            })
          );
        }
      }
    } else {
      for (cutsite of array.slice()) {
        const selectionStartsAtCutSite =
          this.selection.hasStartState('cutsite') &&
          this.selection.getStartState('cutsite') != null &&
          this.selection.getStartState('cutsite')!.cid === cutsite.cid;
        const selectionEndsAtCutSite =
          this.selection.hasEndState('cutsite') &&
          this.selection.getEndState('cutsite') != null &&
          this.selection.getEndState('cutsite')!.cid === cutsite.cid;
        if (selectionStartsAtCutSite || selectionEndsAtCutSite) {
          // eslint-disable-next-line no-restricted-syntax
          array = _.without(array, cutsite);
        }
      }
    }
    this.remove(array);

    for (cutsite of array) {
      cutsite.destroy();
    }

    const trigger = options != null ? options.trigger : true;
    if (trigger) {
      this.trigger('cutsitesChanged');
    }
  }

  getSelected(enzyme: Enzyme, pos: number): CutSite | null {
    const startCut = this.selection.getStartState('cutsite');
    const endCut = this.selection.getEndState('cutsite');
    const start =
      startCut != null && startCut.get('enzyme').id === enzyme.id && startCut.get('position') === pos;
    const end = endCut != null && endCut.get('enzyme').id === enzyme.id && endCut.get('position') === pos;
    if (start) {
      return startCut;
    } else if (end) {
      return endCut;
    }
    return null;
  }

  removeIfInvisible(cutSite: CutSite, selected: boolean): void {
    if (!selected && !cutSite.get('enzyme').get('visible')) {
      this.remove(cutSite);
      cutSite.destroy();
    }
  }

  resetEnzyme(enzyme: Enzyme, options: {trigger: boolean} = {trigger: true}): void {
    if (enzyme.get('visible')) {
      this.changeEnzyme(enzyme, false, options);
      this.changeEnzyme(enzyme, true, options);

      if (options.trigger) {
        return this.trigger('cutsitesChanged');
      }
    }
  }

  createCutSites(enzymes: Enzymes): void {
    const ref = this;
    enzymes.each((enzyme: Enzyme) => {
      if (enzyme.get('visible')) {
        enzyme.get('cutPositions').map((cut: Cut) =>
          ref.add(
            new CutSite({
              enzyme,
              position: cut.position,
              strand: cut.strand,
              color: enzyme.color(),
            })
          )
        );
      }
    });
  }
}
CutSites.initClass();
